module.exports = __webpack_public_path__ + "img/Wp_2028.7a050133.png";